/**
 * Native Shoes — Yotpo Widget Refresh
 * -----------------------------------------------------------------
 * Author:   Anton Siedlecki
 * Date:     2026-09-28
 * Version:  1.1.0
 * Purpose:  snippets/card-product.liquid renders a
 *           .yotpo-widget-instance div per card. Yotpo's loader
 *           (injected via the Shopify app embed, not theme code)
 *           only scans the DOM for these once, on initial page load.
 *           Cards appended later — infinite scroll
 *           (assets/collection-infinite-scroll.js) or a facet/filter
 *           re-render (assets/component-facets.js) — never get their
 *           stars filled in, since Yotpo never sees them.
 *
 *           Both of those already dispatch 'native:grid:updated'
 *           after mutating #product-grid (same event
 *           native-collection-swatches.js and
 *           native-collection-size-filter.js already re-init off of),
 *           so this just adds one more listener that asks Yotpo to
 *           re-scan the DOM.
 *
 * v1.1.0 — Live-confirmed on the storefront that window.yotpo doesn't
 * exist on this store's install; it's the newer Unified Widget Loader,
 * which exposes window.yotpoWidgetsContainer.initWidgets() instead.
 * Swapped to that (v1.0.0's window.yotpo.refreshWidgets() was the
 * classic-loader API and never ran here).
 */

(function () {
  'use strict';

  function refreshYotpoWidgets() {
    if (window.yotpoWidgetsContainer && typeof window.yotpoWidgetsContainer.initWidgets === 'function') {
      window.yotpoWidgetsContainer.initWidgets();
    }
  }

  document.addEventListener('native:grid:updated', refreshYotpoWidgets);
})();
